import AIDetectionIcon from 'Assets/icons/ai-detector.svg'
import { PanelHeader } from 'Components/common/TaskPanelHeader/TaskPanelHeader'
import classes from './AIDetector.module.less'
import { useMemo, useState } from 'react'
import { AIDetectorDetailsType, DisabledStateType } from 'Plugins/AIDetector/AIDetector.plugin'
import { CircleLoader } from 'shared/components/CircleLoader/CircleLoader'
import Tooltip from 'antd/lib/tooltip'
import Button from 'antd/lib/button'
import { AIDetectorDetails } from 'Plugins/AIDetector/component/AIDetectorDetails/AIDetectorDetails'
import Checkbox from 'antd/lib/checkbox/Checkbox'
import InfoCircleFilled from '@ant-design/icons/lib/icons/InfoCircleFilled'

type AIDetectorPropsType = {
    getAIDetectionDetails: () => AIDetectorDetailsType | undefined
    onCheckForAIContent: () => Promise<void>
    getDisabledState: () => DisabledStateType
    isResponseFitForSubmission: boolean
    setIsResponseFitForSubmission: () => void
    maxAIThreshold: number
}

export const AIDetector = (props: AIDetectorPropsType) => {
    const [isLoading, setIsLoading] = useState(false)
    const aiDetectionDetails = props.getAIDetectionDetails()

    const aiDetectorContent = useMemo(() => {
        if (isLoading) {
            return (
                <div className={classes.loadingContainer}>
                    <CircleLoader size={28} />
                    <div>Scanning...Please wait...</div>
                </div>
            )
        } else if (aiDetectionDetails) {
            return (
                <AIDetectorDetails
                    details={aiDetectionDetails}
                    maxAIThreshold={props.maxAIThreshold}
                />
            )
        } else {
            return (
                <div className={classes.hintText}>
                    Click "Scan" and check for AI generated texts in the response before submission
                </div>
            )
        }
    }, [isLoading, aiDetectionDetails, props.maxAIThreshold])

    return (
        <div className={classes.aiDetectionRoot}>
            <PanelHeader logo={AIDetectionIcon} title={'AI Detection'} />

            <div className={classes.body}>{aiDetectorContent}</div>
            <div className={classes.footer}>
                {(props.getAIDetectionDetails()?.percentage ?? 0) > props.maxAIThreshold && (
                    <Checkbox
                        value={props.isResponseFitForSubmission}
                        onChange={props.setIsResponseFitForSubmission}
                        className={classes.confirmationCheckbox}
                    >
                        This response is now fit for submission{' '}
                        <Tooltip
                            trigger="hover"
                            title="Use this options if you feel the AI Detection result is incorrect."
                        >
                            <InfoCircleFilled />
                        </Tooltip>
                    </Checkbox>
                )}
                <Tooltip trigger="hover" title={props.getDisabledState().reason}>
                    <Button
                        className={classes.scanButton}
                        onClick={async () => {
                            setIsLoading(true)
                            await props.onCheckForAIContent()
                            setIsLoading(false)
                        }}
                        disabled={isLoading || props.getDisabledState().isDisabled}
                    >
                        {aiDetectionDetails ? 'Scan again for AI Content' : 'Scan for AI Content'}
                    </Button>
                </Tooltip>
            </div>
        </div>
    )
}
